import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=1c75cf8e&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShoppingCart: require('/var/www/vhosts/bloonde.es/lareverdetienda.bloonde.es/components/core/ShoppingCart.vue').default,Header: require('/var/www/vhosts/bloonde.es/lareverdetienda.bloonde.es/components/blocks/Header.vue').default})
